import { configApi } from "../../../views/utils/api"

export const handleGetStreamerVersion = (val) => (dispatch) => dispatch({ type: "STREAMER_VERSION", val })

export const handleGetStreamerFileName = (val) => (dispatch) => dispatch({ type: "STREAMER_FILE_NAME", val })

export const handleUserInactivity = (val) => async (dispatch) => {
  if (val) {
    dispatch({ type: "HANDLE_USER_INACTIVITY", val })
  } else {
    try {
      const { data } = await configApi.getConfig()
      if (data) {
        dispatch({ type: "HANDLE_USER_INACTIVITY", val: data.data.sleep_interval * 60 * 1000 })
      }
    } catch (error) {
      console.error("Error fetching inactivity time:", error)
    }
  }
}

export const handleLanguageEditMode = (val) => (dispatch) => dispatch({ type: "LANGUAGE_EDIT_MODE", val })

export const handleLanguageModalOpen = (val) => (dispatch) => dispatch({ type: "LANGUAGE_MODAL_OPEN", val })

export const handleRouteTracking = (val) => (dispatch) => dispatch({ type: "ROUTE_TRACKING", val })

export const handleLanguageKey = (val) => (dispatch) => dispatch({ type: "LANGUAGE_KEY", val })

export const handleLanguageWords = (val) => (dispatch) => dispatch({ type: "LANGUAGE_WORDS", val })

export const handleLanguageList = (val) => (dispatch) => dispatch({ type: "LANGUAGE_LIST", val })
